import { reserveService } from "@/services/api/features/reserveService";
import { executeAction, executeDownloadAction } from "@/services/api/helpers";

export default {
  namespaced: true,

  state: {
    loading: {},
    error: {},
  },

  getters: {
    isLoading: (state) => (action) => !!state.loading[action],
    getError: (state) => (action) => state.error[action],
  },

  mutations: {
    SET_LOADING(state, { action, status }) {
      state.loading = { ...state.loading, [action]: status };
    },
    SET_ERROR(state, { action, message }) {
      state.error = { ...state.error, [action]: message };
    },
  },
  actions: {
    async fetchReserveList({ commit }, params) {
      return executeAction({ commit, action: "fetchReserveList" }, () =>
        reserveService.fetchReserveList(params)
      );
    },
    async fetchReserveDetail({ commit }, reserveId) {
      return executeAction({ commit, action: "fetchReserveDetail" }, () =>
        reserveService.fetchReserveDetail(reserveId)
      );
    },
    async patchReserveStatus({ commit }, params) {
      return executeAction({ commit, action: "patchReserveStatus" }, () =>
        reserveService.patchReserveStatus(params)
      );
    },
    async confirmResrve({ commit }, params) {
      return executeAction({ commit, action: "confirmResrve" }, () =>
        reserveService.confirmResrve(params)
      );
    },
    async fetchResrveExportOption({ commit }, ) {
      return executeAction({ commit, action: "fetchResrveExportOption" }, () =>
        reserveService.fetchResrveExportOption()
      );
    },
    async fetchResrveExportFile({ commit },params) {
      return await executeDownloadAction(
        { commit, action: "fetchResrveExportFile" },
        () => reserveService.fetchResrveExportFile(params),
        "Reservation_Report.xlsx"
      );
    },
  },
};
